/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

export type ErrorIconProps = {
  color?: string;
  size?: IconSize | number;
}
/*
 * Defines the Design Language System (DLS) Error Icon component.
 */
export const ErrorIcon = ({color = dlsColor('grey3'), size = IconSize.medium}: ErrorIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 7V13.3792" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M12 14.5284V16.292" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5"/>
    </svg>
  );
};

export default ErrorIcon;
